/**
 * Copyright (c) 2018-2019 Aleksey Melnikov, True Directive Company.
 * @link https://truedirective.com/
 * @license MIT
*/
import { Injectable, Injector, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs';

import { GridEvents } from './grid-events.class';
import { GridSelection } from './grid-selection.class';
import { InternationalizationService } from './internationalization/internationalization.service';

import { GridState, GridExporter } from '@true-directive/base';
import { Column } from '@true-directive/base';
import { CellPosition } from '@true-directive/base';
import { DataQuery } from '@true-directive/base';
import { CheckedChangedEvent, ValueChangedEvent, FilterShowEvent } from '@true-directive/base';
import { UIAction } from '@true-directive/base';
import { DOMUtils } from './common/dom-utils.class';
import { AxInject, AxInjectConsumer } from '@true-directive/base';

@Injectable()
// @AxInjectConsumer
export class GridStateService extends GridState implements OnDestroy {

  focusChangedSubscription: any;
  selectionChangedSubscription: any;
  localeChangedSubscription: any;

  @AxInject('events')
  public events: GridEvents;

  @AxInject('selection')
  public selection: GridSelection;

  // ÐÐ½Ð¸ÑÐ¸Ð¸ÑÑÐµÐ¼ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ðµ Ð´Ð°Ð½Ð½ÑÑ ÑÐ¾ Ð²ÑÐµÐ¼Ð¸ Ð¿ÐµÑÐµÑÑÑÑÐ°Ð¼Ð¸
  public updateDataAsync(): Observable<any> {
    const subject = new Subject<any>();
    if (this.settings.requestData) {
      // ÐÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð·Ð°Ð¿ÑÐ¾ÑÐ¸ÑÑ Ð´Ð°Ð½Ð½ÑÐµ
      this.doQuery(subject);
      // ÐÐ! ÐÑÐ¶Ð½Ð¾ Ð¾Ð±Ð½Ð¾Ð²Ð¸ÑÑ ÐºÐ¾Ð»Ð¾Ð½ÐºÐ¸.
      this.events.columnsChangedEvent();
      return subject;
    }

    // ÐÐ°Ð¿ÑÐ°ÑÐ¸Ð²Ð°ÑÑ Ð½Ðµ Ð½ÑÐ¶Ð½Ð¾, ÑÑÐ¸ÑÐ°ÐµÐ¼ Ð²ÑÑ ÑÐ°Ð¼Ð¸
    // ÐÑÐ¸Ð½ÑÑÐ¾Ð½Ð½Ð¾Ðµ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ðµ
    this.recalcData().then(() => {
      this.fetchData(new DataQuery(this._dataQueryCounter));
      let rc;
      if (this.dataSource.resultRows) {
        rc = this.dataSource.resultRows.length;
      }
      subject.next(rc);
      subject.complete();
    });

    return subject;
  }

  public copySelectionToClipboard(withHeaders: boolean) {
    DOMUtils.copyToClipboard(this.getSelectedData(this.selection).toString(withHeaders, '\t')
    );
  }

  public exportToCSV(fileName: string, columnSeparator: string = ',') {
    DOMUtils.downloadCSV(fileName, this.dataToExport().toString(true, columnSeparator, true));
  }

  ngOnDestroy() {
    this.focusChangedSubscription.unsubscribe();
    this.selectionChangedSubscription.unsubscribe();
    this.localeChangedSubscription.unsubscribe();
  }

  /*
  // ÐÐ°Ð¶Ð½Ð¾ Ð¾Ð±Ð½Ð¾Ð²Ð¸ÑÑ Ð²ÑÐ´ÐµÐ»ÐµÐ½Ð½ÑÐµ Ð¾Ð±Ð»Ð°ÑÑÐ¸ Ð² layouts
  protected subscribe() {
    this.events.onSelect.subscribe((cp: CellPosition) => {
      this.layoutsHandler.updateLayoutSelections(cp);
    });
  }
  */
 
  protected registerHandlers() {
    super.registerHandlers();
    this.handlers['events'] = GridEvents;
    this.handlers['selection'] = GridSelection;
  }

  constructor(public internationalization: InternationalizationService) {
    super();

    this.focusChangedSubscription = (<GridSelection>this.selection).onFocusChanged.subscribe(v => {
      this.layoutsHandler.updateLayoutSelections(v);
      this.focusChanged(v);
    });

    // ÐÑÐ¸ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ð¸ Ð²ÑÐ´ÐµÐ»ÐµÐ½Ð¸Ñ - Ð¾Ð±Ð½Ð¾Ð²Ð¸ÑÑ Ð² Ð»ÑÐ¹Ð°ÑÑÐ°Ñ. ÐÐ¾ ÑÐµÐ¹ÑÐ°Ñ Ð½Ð°Ð¾Ð±Ð¾ÑÐ¾Ñ
    this.selectionChangedSubscription = (<GridSelection>this.selection).onSelectionChanged.subscribe(v => {
      this.layoutsHandler.updateLayoutSelections(v);
      this.events.selectEvent(v);
    });

    this.localeChangedSubscription = this.internationalization.onLocaleChanged.subscribe(locale => {
      this.dataSource.valueFormatter.setLocale(locale);
    });
  }
}
